// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Button, Input } from 'semantic-ui-react'

export default class MailChimp extends Component {
  render () {
    return (
      <div>
        <div id='mc_embed_signup'>
          <form
            action='https://gmail.us20.list-manage.com/subscribe/post?u=bead18bdff2354ad087379661&amp;id=c0e53f61be'
            method='post'
            id='mc-embedded-subscribe-form'
            name='mc-embedded-subscribe-form'
            className='validate'
            target='_blank'
            rel='noopener noreferrer'
            noValidate>
            <div className='mc-field-group'>
              <Input
                type='email'
                placeholder='name@example.com'
                name='EMAIL'
                className='required email'
                id='mce-EMAIL'
              />
            </div>
            <div id='mce-responses' className='clear'>
              <div className='response' id='mce-error-response' style={{ display: 'none' }} />
              <div className='response' id='mce-success-response' style={{ display: 'none' }} />
            </div>
            <br clear='all' />
            <Button
              type='submit'
              compact
              basic
              color='black'
              name='subscribe'
              id='mc-embedded-subscribe'>
              Join our newsletter!
            </Button>
          </form>
        </div>
      </div>
    )
  }
}
